// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7aa5f453","67":"7a2a77f9","161":"03d94e56","275":"5f8b0440","675":"047e832f","747":"fe9362f0","884":"c5e04998"}[chunkId] + ".chunk.js";
};